module.exports = __webpack_public_path__ + "img/troll_bogeys.5c5dcb29.jpg";